import { Controller } from "@hotwired/stimulus"

// Show / hide a password field. The two eye icons swap; the button's label says what it will do.
export default class extends Controller {
  static targets = ["input", "button", "show", "hide"]

  toggle() {
    if (!this.hasInputTarget) return
    const reveal = this.inputTarget.type === "password"
    this.inputTarget.type = reveal ? "text" : "password"
    if (this.hasShowTarget) this.showTarget.classList.toggle("hidden", reveal)
    if (this.hasHideTarget) this.hideTarget.classList.toggle("hidden", !reveal)
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-label", reveal ? "Hide password" : "Show password")
      this.buttonTarget.setAttribute("aria-pressed", String(reveal))
    }
  }
}
